import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "site-name-class" }
const _hoisted_3 = { class: "flex justify-content-between" }
const _hoisted_4 = { class: "ml-auto mr-3 flex align-items-center justify-content-around" }
const _hoisted_5 = { class: "structure-class" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_user_dropdown = _resolveComponent("user-dropdown")!
  const _component_Menubar = _resolveComponent("Menubar")!

  return (_openBlock(), _createBlock(_component_Menubar, { class: "layout-topbar pl-4 pr-4 w-full" }, {
    start: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "align-self-center py-0",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.menuClickEvent(_ctx.workingSpacePath)))
        }, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.siteName), 1)
        ])
      ])
    ]),
    end: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "px-5 py-0",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.menuClickEvent(_ctx.workingSpacePath)))
          }, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.structureName), 1)
          ])
        ]),
        _createVNode(_component_user_dropdown, { workingSpacePath: _ctx.workingSpacePath }, null, 8, ["workingSpacePath"])
      ])
    ]),
    _: 1
  }))
}